import { useEffect, useState } from "react";
import { getUserComments } from "../../../services/commentService";
import { ChevronDown } from "lucide-react";
import CommentCard from "./CommentCard";
import CommentCardSkeleton from "../Skeleton/Comments/CommentCardSkeleton";

export default function DashboardComments() {

  const [comments, setComments] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserComments().then((data) => {
      console.log("Data:",data);
      setComments(data);
      setLoading(false);
    });
  }, []);

  const showMore = () => {
    setVisibleCount((prev) => prev + 2);
  };

  const visibleComments = comments.slice(0, visibleCount);

  if (loading) {
    return (
    <>
    <CommentCardSkeleton />
    <CommentCardSkeleton />
    <CommentCardSkeleton />
    <CommentCardSkeleton />
  </>
    );
  }


  return (
   

    <div className="wrapper">
      <h2>
        <span> کامنت های من </span>
      </h2>

      {visibleComments.map(c => (
  <CommentCard key={c.id} comment={c} />
))}

      <div className="wrapper-footer">
        {comments.length > visibleCount && (
          <button onClick={showMore} className="show-more-btn">
            نمایش بیشتر
            <ChevronDown color="#95b73c" />         
          </button>
        )}
      </div>

    



    </div>
  );
}
